(function (module) {
    "use strict";

    module.service('chamferingCorrectionAboutFactsForecastService', ['synchronousEventsBus', 'correctionAboutFactsService',
        function(
            this: $TSFixMe,
            synchronousEventsBus: $TSFixMe,
            correctionAboutFactsService: $TSFixMe
        ) {
            var service = this;

            service.registerEvents = function () {
                synchronousEventsBus.$on('skuChamferingChange', function (e: $TSFixMe, args: $TSFixMe) {
                    args.forecast.volume.pmForecast = correctionAboutFactsService.reclaculate(args.forecast.volume.statisticalForecast, args.parameters, args.forecast.correction);
                    return synchronousEventsBus.$broadcast('chamferingSkuVolumePmForecastChanged', { forecast: args.forecast, parameters: args.parameters });
                });
            }

            service.removeCorrect = function (start: $TSFixMe, end: $TSFixMe, forecast: $TSFixMe, parameters: $TSFixMe) {
                forecast.volume.pmForecast = correctionAboutFactsService.removeCorrection(forecast.volume.statisticalForecast, parameters, forecast.correction, start, end);
                return synchronousEventsBus.$broadcast('chamferingSkuVolumePmForecastChanged', { forecast: forecast, parameters: parameters });
            };

            service.updateCorrect = function (correctionFact: $TSFixMe, forecast: $TSFixMe, parameters: $TSFixMe) {
                if (!forecast.correction) {
                    forecast.correction = [];
                }
                forecast.volume.pmForecast = correctionAboutFactsService.addOrUpdateCorrection(forecast.volume.statisticalForecast, parameters, forecast.correction, correctionFact);
                return synchronousEventsBus.$broadcast('chamferingSkuVolumePmForecastChanged', { forecast: forecast, parameters: parameters });
            };
        }]);

    module.run(['chamferingCorrectionAboutFactsForecastService', (service: $TSFixMe) => { service.registerEvents(); }]);

})(angular.module('topline.services'));